"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.CommonThematic = exports.InvestorsThematic = exports.Thematic = void 0;
var expertise_1 = require("./expertise");
var Thematic;
(function (Thematic) {
    Thematic["Bank"] = "bank";
    Thematic["LetterPackage"] = "letter-package";
    Thematic["Dt"] = "dt";
    Thematic["InformationsFinancieres"] = "informations-financieres";
    Thematic["Innovation"] = "innovation";
    Thematic["Culture"] = "culture";
    Thematic["Logistic"] = "logistic";
    Thematic["Medias"] = "medias";
    Thematic["Partnership"] = "partnership";
    Thematic["HumanResource"] = "human-resource";
    Thematic["NouveauxServices"] = "nouveaux-services";
    Thematic["Group"] = "group";
    Thematic["Numerique"] = "numeric";
    Thematic["Ecology"] = "ecology";
    Thematic["Philately"] = "philately";
})(Thematic = exports.Thematic || (exports.Thematic = {}));
var InvestorsThematic;
(function (InvestorsThematic) {
    InvestorsThematic["Results"] = "results";
    InvestorsThematic["Acquisitions"] = "acquisitions";
    InvestorsThematic["Strategy"] = "strategy";
    InvestorsThematic["Governance"] = "governance";
    InvestorsThematic["Emissions"] = "emissions";
    InvestorsThematic["BSCC"] = "BSCC";
    InvestorsThematic["GEOPOST"] = "GEOPOST";
    InvestorsThematic["LBP"] = "LBP";
    InvestorsThematic["CNP"] = "CNP";
    InvestorsThematic["BGPN"] = "BGPN";
    InvestorsThematic["Other"] = "other";
})(InvestorsThematic = exports.InvestorsThematic || (exports.InvestorsThematic = {}));
// eslint-disable-next-line @typescript-eslint/no-redeclare
exports.CommonThematic = __assign(__assign({}, Thematic), expertise_1.Expertise);
//# sourceMappingURL=thematic.js.map